export enum EGeometryType {
  Polygon = 'Polygon',
  MultiPolygon = 'MultiPolygon'
}

export interface IGeometry {
  type: EGeometryType
  coordinates: GeoJSON.Position[] | GeoJSON.Position[][]
}
